import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { Field, Errors } from 'react-redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';
import classnames from 'classnames';
import Tooltip from './tooltip';
class Datepicker extends Component {
    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });
        return (
            <div className={formRowClassNames}>
                {this.props.tooltip && (
                    <Tooltip
                        title={this.props.tooltip}
                        className="form-tooltip"
                    />
                )}
                <div className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                </div>
                <div className="form__label--date">
                    <Field
                        model={this.props.model}
                        id={this.props.model}
                        mapProps={{
                            selected: props => props.modelValue
                        }}
                        validators={this.props.validators}
                    >
                        <DatePicker
                            id={this.props.id}
                            dateFormat="YYYY-MM-DD"
                            className="form__textfield"
                            title={this.props.title}
                            readOnly
                            isClearable={this.props.isClearable}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            onBlur={this.props.onBlur}
                            disabled={this.props.disabled}
                            onChange={this.props.onChange}
                            minDate={this.props.minDate}
                            maxDate={this.props.maxDate}
                            startDate={this.props.startDate}
                            endDate={this.props.endDate}
                            selected={this.props.selected}
                            selectsStart={this.props.selectsStart}
                            selectsEnd={this.props.selectsEnd}
                        />
                    </Field>
                    <Errors
                        wrapper={props => (
                            <div className="form__error-messages">
                                {props.children}
                            </div>
                        )}
                        className="errors"
                        model={this.props.model}
                        show="touched"
                        messages={this.props.messages}
                    />
                    <label>
                        <svg className="icon icon-calendar">
                            <use
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                xlinkHref="#icon-calendar"
                            />
                        </svg>
                    </label>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => {
    return {
        valid: get(state.forms, `${model}.valid`, false),
        touched: get(state.forms, `${model}.touched`, false)
    };
};

export default connect(mapStateToProps)(Datepicker);



// WEBPACK FOOTER //
// ./src/components/ui/datepicker.js